import React from 'react'

import { getErrorMessage } from 'utils'

import { useSnackbar } from 'contexts'
import { useRemoveMember, useWorkOSAuth } from 'hooks'

import { useTheme, Stack, Typography, Box } from '@mui/material'

import { Modal, Button } from '@repo/ui'
import { UserBlock } from 'components'




interface DeleteCompanyUserModalProps {
  user: any
  open: boolean
  onClose: () => void
  refetch: () => void
}

export const DeleteCompanyUserModal = (props: DeleteCompanyUserModalProps) => {
  const { user, open, onClose = () => {}, refetch } = props
  const theme = useTheme()

  const { open: notification } = useSnackbar()

  const { mutate: removeMember, isPending } = useRemoveMember({
    onSuccess: () => {
      handleClose()
      refetch()
    },
    onError: (error: any) => {
      const message = getErrorMessage(error)
      notification({
        type: 'error',
        title: message,
      })
    },
  })

  const handleDeleteUser = () => {
    if (!user?.id) {
      notification({
        type: 'error',
        title: 'Cannot delete user: User ID not found',
      })
      return
    }
    removeMember({ userId: user.id })
  }

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal title="Delete user" open={open} onClose={handleClose} actions={
        <>
 <Button
          disableElevation
          variant="secondary"
          onClick={() => handleClose()}
          disabled={isPending}
        >
          Cancel
        </Button>

        <Button
          disableElevation
          destructive
          loading={isPending}
          onClick={() => handleDeleteUser()}
        >
          Delete
        </Button>
        </>
      }>
      <Stack spacing="16px" mb={6}>
        <Box sx={{ p: 3, borderRadius: 2, border: `1px solid ${theme.palette.divider}` }}>
          <UserBlock user={user} />
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>{`Permanently delete "${user?.first_name} ${user?.last_name}" from this company? This removes their membership and access and cannot be undone. To keep their record, use Archive instead.`}</Typography>
      </Stack>
    </Modal>
  )
}
